<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addBusinessRouterName" v-if="permissionCodes.indexOf('001002001') !== -1"/>
        <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('001002002') !== -1"/>
      </div>
      <input-search placeholder="标题" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" @changeSwitch="changeSwitch" :deleteTipInfo="'是否确认删除园区公告？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/yqNotice'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'yq-notice-management',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '园区公告'
      }],
      addBusinessRouterName: 'add-yq-notice',
      selectTitle: '租赁状态',
      operationArr: ['modify', 'delete'],
      tableHead: [{
        prop: 'title',
        label: '标题'
      }, {
        prop: 'responsiblePersonName',
        label: '添加人'
      }, {
        prop: 'isTopInPageState',
        label: '是否置顶',
        isSwitch: true
      }, {
        prop: 'readingCount',
        label: '阅读数'
      }, {
        prop: 'createTime',
        label: '添加时间'
      }],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        searchKey: '',
        pageSize: 10,
        pageNum: 1,
      },
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getPage()
  },
  activated() {
    this.getPage()
  },
  methods: {
    getPage () {
      this.$axios.post(api.getYqNoticePage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {
              v.createTime = v.createTime.slice(0, 19)
              if (v.noticeType === '1') {
                v.noticeTypeText = '宣传'
              } else if (v.noticeType === '2') {
                v.noticeTypeText = '新闻'
              } else if (v.noticeType === '3') {
                v.noticeTypeText = '安全提示'
              } else if (v.noticeType === '4') {
                v.noticeTypeText = '通知'
              } else if (v.noticeType === '5') {
                v.noticeTypeText = '其他'
              }
              if (v.isTop === '1') {
                v.isTopInPageState = true
              } else {
                v.isTopInPageState = false
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取公告失败'))
    },
    search (v) {
      this.requestData.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.requestData.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.requestData.pageNum = data[0]
      this.requestData.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    goToModifyPage (code) {
      this.$router.push({
        path: `/modify_yq_notice/${code}`
      })
    },
    deleteSelection () {
      if (this.selectionArr.length === 0) {
        nAlert('请先选择需要删除的园区公告')
        return false
      } else {
        this.$confirm('是否确认删除园区公告？', '提示')
          .then(() => {
            this.deleteLine(this.selectionArr)
          })
          .catch(() => {
            console.log('取消删除')
          })
      }
    },
    deleteLine (code) {
      this.$axios.post(api.deleteyqNoticeByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.selectionArr = []
            this.getPage()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    // 修改置顶状态
    changeSwitch (data) {
      this.$confirm('是否确认修改该置顶状态？', '提示')
        .then(() => {
          if (data.isTopInPageState) {
            data.isTop = '1'
          } else {
            data.isTop = '0'
          }
          for (let i in data) {
            if (data[i] === '--') {
              data[i] = ''
            }
          }
          this.$axios.post(api.updateyqNotice, data)
            .then(res => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(errorHandler('修改失败'))
        })
        .catch(() => {
          this.getPage()
        })
    },
  },
  watch: {
    centEndTime(val) {
      this.getPage()
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/YqNoticeManagement/YqNoticeManagement.vue